'use strict';

var googleRecaptcha = require('int_google/googleRecaptcha');
var scrollAnimate = require('base/components/scrollAnimate');

/**
 * Validates all required contact form fields and consent checkboxes.
 * Adds/removes Bootstrap `.is-invalid` class to indicate field errors.
 * @param {jQuery} $form - The contact form jQuery element
 * @returns {boolean} true when all fields are valid
 */
function validateForm($form) {
    var isValid = true;

    // Required text / email / textarea fields
    ['#name', '#email', '#subject', '#description'].forEach(function (selector) {
        var $field = $form.find(selector);
        if (!$field.val() || !$field.val().trim()) {
            $field.addClass('is-invalid');
            isValid = false;
        } else {
            $field.removeClass('is-invalid');
        }
    });

    // Required select dropdowns
    var $category = $form.find('#category');
    if (!$category.val()) {
        $category.addClass('is-invalid');
        isValid = false;
    } else {
        $category.removeClass('is-invalid');
    }

    var $subCategory = $form.find('#subCategory');
    if (!$subCategory.prop('disabled') && !$subCategory.val()) {
        $subCategory.addClass('is-invalid');
        isValid = false;
    } else {
        $subCategory.removeClass('is-invalid');
    }

    // GDPR consent checkboxes
    ['#termsOfUse', '#privacyPolicy'].forEach(function (selector) {
        var $checkbox = $form.find(selector);
        if (!$checkbox.prop('checked')) {
            $checkbox.addClass('is-invalid');
            isValid = false;
        } else {
            $checkbox.removeClass('is-invalid');
        }
    });

    return isValid;
}

module.exports = {
    handleSubmit: function () {
        $(document).on('submit', '.contact-form', function (e) {
            e.preventDefault();
            var $form = $(this);

            if (!validateForm($form)) {
                scrollAnimate($form.find('.is-invalid').first());
                return;
            }

            (googleRecaptcha.getRecaptchaToken()).then((recaptchaTokenData) => {
                if (recaptchaTokenData && recaptchaTokenData.success) {
                    let formData = $form.serialize();
                    formData = formData + '&recaptchaToken=' + recaptchaTokenData.recaptchaToken;
                    $.ajax({
                        url: $form.attr('action'),
                        method: 'POST',
                        data: formData,
                        success: function (response) {
                            if (response.recaptchaError) {
                                if (response.recaptchErrorMsg) {
                                    $('.error-message').removeClass('d-none');
                                    $('.error-message-text').text(response.recaptchErrorMsg);
                                    scrollAnimate($('.error-message'));
                                }
                                return;
                            }
                            if (response.success) {
                                $('.form-container').addClass('d-none');
                                $('.success-container').removeClass('d-none');
                                $form.trigger('reset');
                            } else {
                                $('.form-container').addClass('d-none');
                                $('.error-container').removeClass('d-none');
                            }
                        }
                    });
                }
            }).catch(function (error) {
                if (error && error.errorMsg) {
                    $('.error-message').removeClass('d-none');
                    $('.error-message-text').text(error.errorMsg);
                    scrollAnimate($('.error-message'));
                }
            });
        });

        // Clear validation state as the user corrects individual fields
        $(document).on('change input', '.contact-form input, .contact-form textarea, .contact-form select', function () {
            var $field = $(this);
            if ($field.is(':checkbox')) {
                if ($field.prop('checked')) {
                    $field.removeClass('is-invalid');
                }
            } else if ($field.val() && $field.val().trim()) {
                $field.removeClass('is-invalid');
            }
        });
    },
    handleDropdowns: function () {
        var webToCaseConfig = JSON.parse($('#webToCaseConfig').val());

        if (webToCaseConfig && Object.keys(webToCaseConfig).length > 0) {
            Object.keys(webToCaseConfig).forEach(key => {
                $('.category-dropdown option[optionid="' + key + '"]').removeClass('d-none');
            });
        }

        $('.category-dropdown').on('change', function () {
            var selectedCategory = $('.category-dropdown option:selected').attr('optionid');

            // Enable sub-category dropdown
            $('.sub-category-dropdown').prop('disabled', false);

            // Clear existing options
            $('.sub-category-dropdown option').each(function () {
                if ($(this).val() !== '') {
                    $(this).addClass('d-none');
                }
            });

            // Show relevant sub-categories
            if (webToCaseConfig && webToCaseConfig[selectedCategory]) {
                webToCaseConfig[selectedCategory].forEach(function (subCat) {
                    $('.sub-category-dropdown option[optionid="' + subCat + '"]').removeClass('d-none');
                });
            }

            // Reset sub-category selection
            $('.sub-category-dropdown').val('');
            $('.sub-category-dropdown').removeAttr('disabled');
        });
    }
};
